import { createCachedSelector, path, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { searchFilterStoreSelector } from '../searchFilter.selector';

export const searchFilterSelector = createCachedSelector(
  [
    path(searchFilterStoreSelector).search(),
  ],
  (search) => {
    return search;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
